<script setup>
import DashboardStatsAdminCard from '@/Components/Dashboard/DashboardStatsAdminCard'
import ExpiredIcon from '@/icons/ExpiredIcon'
import moment from 'moment';

import { computed } from 'vue'

const props = defineProps({
	jobs: {
		type: Array,
		default: null,
	},
})

const lastFailedJob = computed(() => {
	if(props.jobs === null) return null
	
	return props.jobs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
		[0]
})

const mostRecentFailureDate = computed(() => {
	if(props.jobs === null || !props.jobs.length) return 0
	let date = props.jobs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0].created_at
	return moment(date).format('dddd Mo MMM YYYY h:mma')
})

</script>
<template>
	<BlockLoader class="h-64 w-full" v-if="jobs === null" />
		
	<DashboardStatsAdminCard
		:icon=ExpiredIcon
		v-if="jobs"
		:data="jobs.length"
		caption="Failed Jobs"
		linkText="View server Logs"
		:href="route('dashboard.logs.index')"
		class="text-center"
	>
		<div class="flex flex-col">
			<p class="text-sm py-2 font-bold">last 30 days</p>
			
			<Link
				:href="route('dashboard.logs.show', lastFailedJob.id)"
				v-if="mostRecentFailureDate"
				class="text-xs bg-Red text-white px-2 py-1 rounded-xl mt-2 no-underline hover:underline"
			>
				last failed job<br />
				{{ mostRecentFailureDate }}
			</Link>
		</div>
	</DashboardStatsAdminCard>
</template>